import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, setToken, setStoredRole, getStoredRole } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [admin, setAdmin] = useState(null);
    const [role, setRole] = useState(getStoredRole());
    const [mustChangePin, setMustChangePin] = useState(false);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get('/auth/me');
            if (data.role === 'user') {
                setUser(data.user);
                setAdmin(null);
                setRole('user');
                setStoredRole('user');
                setMustChangePin(!!data.must_change_pin);
            } else if (data.role === 'superadmin') {
                setAdmin(data.admin);
                setUser(null);
                setRole('superadmin');
                setStoredRole('superadmin');
            }
        } catch (e) {
            setUser(null);
            setAdmin(null);
            setRole(null);
            setToken(null);
            setStoredRole(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const loginUser = async (nickname, pin) => {
        const { data } = await api.post('/auth/login', { nickname, pin });
        setToken(data.token);
        setUser(data.user);
        setAdmin(null);
        setRole('user');
        setStoredRole('user');
        setMustChangePin(!!data.must_change_pin);
        return data;
    };

    const loginAdmin = async (email, password) => {
        const { data } = await api.post('/admin/login', { email, password });
        setToken(data.token);
        setAdmin(data.admin);
        setUser(null);
        setRole('superadmin');
        setStoredRole('superadmin');
        return data;
    };

    const logout = () => {
        setToken(null);
        setStoredRole(null);
        setUser(null);
        setAdmin(null);
        setRole(null);
        setMustChangePin(false);
    };

    return (
        <AuthContext.Provider value={{ user, admin, role, mustChangePin, setMustChangePin, loading, loginUser, loginAdmin, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
